/* Jellyfin's native public-user chooser and password form stay in place.
   The native controller retains auth, validation, focus and visibility. */
/* Keep Jellyfin's or the installed theme's login backdrop visible. */
body.tvl-login-native { color:#f5f5f2; }
.tvl-login-native .skinHeader { background:linear-gradient(180deg,#101112e6,transparent); }
.tvl-login-native #loginPage {
  box-sizing:border-box;min-height:100vh;
  padding:5rem 0 2rem!important;
  color:#f5f5f2;font-family:'Segoe UI','Helvetica Neue',Arial,sans-serif;
}
.tvl-login-native #loginPage>.padded-left.padded-right.padded-bottom-page {
  box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;
  width:100%!important;min-height:calc(100vh - 7rem);max-width:1440px;margin:0 auto!important;
  padding:1.5rem 5vw 3rem!important;
  background:transparent;backdrop-filter:none;border-radius:0;transform:none;
}
.tvl-login-native #loginPage>.padded-left::before {
  content:'SCREENHARBOUR';display:block;margin:0 0 2rem;
  max-width:100%;white-space:normal;overflow-wrap:break-word;word-break:break-word;
  color:#b9cdbc;font-size:.78rem;font-weight:650;letter-spacing:.3em;text-align:center;
}
.tvl-login-native #loginPage>.padded-left[data-tvl-title]::before { content:attr(data-tvl-title); }
.tvl-login-native #loginPage>.padded-left[data-tvl-title='']::before { display:none;margin:0; }
.tvl-login-native #loginPage .visualLoginForm { width:100%; }
.tvl-login-native #loginPage .manualLoginForm::before,
.tvl-login-native #loginPage .visualLoginForm::before { content:none;display:none; }
.tvl-login-native #loginPage h1 {
  display:block;
  color:#f5f5f2;font-size:3.4rem;font-size:clamp(2rem,4vw,4rem);
  font-weight:700;line-height:1.08;letter-spacing:-.045em;margin:0 0 1.4rem!important;
  text-align:center;overflow-wrap:break-word;
}
.tvl-login-native #divUsers {
  display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:center;
  width:100%;box-sizing:border-box;margin:.5rem auto 1.7rem;padding:.5rem;
}
.tvl-login-native #divUsers .card {
  flex:0 0 11.5rem;width:11.5rem;max-width:100%;margin:.6rem;padding:.35rem;
  background:transparent;border:0;border-radius:12px;color:#f5f5f2;
}
.tvl-login-native #divUsers .cardBox { margin:0!important;padding-bottom:.3rem;background:transparent;box-shadow:none;transform:none!important; }
.tvl-login-native #divUsers .cardScalable { border-radius:12px;box-shadow:0 12px 30px #0005; }
.tvl-login-native #divUsers .cardContent,
.tvl-login-native #divUsers .cardImage,
.tvl-login-native #divUsers .cardImageContainer { border-radius:12px;background-color:#2a4033; }
.tvl-login-native #divUsers .cardImageIcon { font-size:5rem;color:#c6d6c9; }
.tvl-login-native #divUsers .cardFooter,
.tvl-login-native #divUsers .cardText { background:transparent;color:#f5f5f2; }
.tvl-login-native #divUsers .cardText {
  height:auto;max-height:none;margin:0;padding:.9rem .2rem .2rem;
  line-height:1.35;font-size:1.05rem;font-weight:600;white-space:normal;overflow-wrap:break-word;
}
.tvl-login-native #divUsers .card:hover .cardScalable { box-shadow:0 0 0 2px #8cae98,0 12px 30px #0005; }
.tvl-login-native #divUsers .card:focus { outline:3px solid #e0f0e4!important;outline-offset:3px; }
.tvl-login-native #loginPage .manualLoginForm {
  box-sizing:border-box;width:100%;max-width:30rem;margin:0 auto!important;padding:2rem;
  background:#19241de6;border:1px solid #c4d9cf30;border-radius:14px;box-shadow:0 18px 70px #0005;
}
.tvl-login-native #loginPage .manualLoginForm>.padded-left { padding:0; }
.tvl-login-native #loginPage .manualLoginForm h1 { font-size:2.2rem;margin:0 0 1.8rem!important; }
.tvl-login-native #loginPage .inputContainer { margin-bottom:1.4rem; }
.tvl-login-native #loginPage .inputLabel,
.tvl-login-native #loginPage .checkboxLabel { color:#c9d6cd; }
.tvl-login-native #loginPage .emby-input,
.tvl-login-native #loginPage input[is=emby-input] {
  box-sizing:border-box;width:100%;min-height:3.2rem;padding:.75rem .85rem!important;
  background:#101a14;border:1px solid #587060;border-radius:7px;color:#f5f5f2;font:inherit;
}
.tvl-login-native #loginPage input::placeholder { color:#9eb0a4;opacity:1; }
.tvl-login-native #loginPage .checkboxContainer { color:#c9d6cd;margin:1.1rem 0 1.5rem; }
.tvl-login-native #loginPage .checkboxOutline { border-color:#9ab6a3;border-radius:4px; }
.tvl-login-native #loginPage .emby-checkbox:checked+span+.checkboxOutline { background:#cfe2d4;border-color:#cfe2d4;color:#142018; }
.tvl-login-native #loginPage .emby-checkbox:focus+span+.checkboxOutline { border-color:#e0f0e4!important;outline:2px solid #e0f0e4;outline-offset:3px; }
.tvl-login-native #loginPage .raised {
  box-sizing:border-box;min-height:3rem;margin:.35rem 0;padding:.85rem 1rem;
  background:#26382c;color:#edf4ef;border:1px solid #c4d9cf26;border-radius:7px;
  box-shadow:none;font:inherit;font-weight:600;line-height:1.3;white-space:normal;transform:none;
}
.tvl-login-native #loginPage .raised:hover { background:#354e3e;color:#fff; }
.tvl-login-native #loginPage .raised:focus { background:#354e3e!important;color:#f5f5f2!important; }
.tvl-login-native #loginPage .button-submit,
.tvl-login-native #loginPage .button-submit:focus { background:#f5f5f2!important;color:#101112!important;border-color:#f5f5f2!important; }
.tvl-login-native #loginPage .button-submit:hover { background:#d3e7de!important;color:#101112!important; }
.tvl-login-native #loginPage .emby-input:focus { border-color:#9ab6a3!important; }
.tvl-login-native #loginPage button:focus,
.tvl-login-native #loginPage input:focus,
.tvl-login-native #loginPage a:focus { outline:2px solid #e0f0e4!important;outline-offset:4px; }
.tvl-login-native #loginPage button:disabled { opacity:.45; }
.tvl-login-native #loginPage .readOnlyContent {
  box-sizing:border-box;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:.65rem;
  width:100%;max-width:40rem;margin:1.6rem auto 0!important;
}
.tvl-login-native #loginPage .readOnlyContent>.raised { width:100%;margin:0; }
.tvl-login-native #loginPage .loginDisclaimerContainer { grid-column:1 / -1;margin:1.2rem 0 0; }
.tvl-login-native #loginPage .loginDisclaimer { color:#abbdb0;font-size:.9rem;line-height:1.6;overflow-wrap:break-word; }
.tvl-login-native #loginPage .loginDisclaimer a { color:#d3e7de; }

/* Quick Connect and failed-login alerts are native dialogs outside loginPage.
   Keep their native roles, text, focus trap and closing actions. */
.tvl-login-native .dialog.formDialog { background:#101712f5;color:#f5f5f2; }
.tvl-login-native .formDialog .formDialogHeader,
.tvl-login-native .formDialog .formDialogFooter { background:transparent;color:#f5f5f2; }
.tvl-login-native .formDialog .formDialogHeaderTitle { font-size:2rem;line-height:1.2;letter-spacing:-.025em; }
.tvl-login-native .formDialog .formDialogContent { box-sizing:border-box;max-width:40rem!important;width:calc(100% - 3rem);border:1px solid #c4d9cf30;border-radius:12px;background:#1b2920; }
.tvl-login-native .formDialog .dialogContentInner { box-sizing:border-box;padding:1.5rem!important;font-size:1.1rem;line-height:1.65;overflow-wrap:break-word; }
.tvl-login-native #quickConnectAlert .text { font-size:1.35rem;font-variant-numeric:tabular-nums; }
.tvl-login-native .formDialog .raised,
.tvl-login-native .formDialog .raised:focus { background:#f5f5f2!important;color:#101112!important;border-color:#f5f5f2!important;min-height:3rem;padding:.8rem 1.4rem;border-radius:7px;box-shadow:none; }
.tvl-login-native .formDialog button:focus { outline:2px solid #e0f0e4!important;outline-offset:4px; }
.tvl-login-native .toast { max-width:calc(100vw - 2rem);min-width:0;background:#352923!important;color:#fff0e5;border:1px solid #caac9766!important;border-radius:9px;line-height:1.5;box-shadow:0 10px 35px #0008; }
@media(max-width:680px) {
  .tvl-login-native #loginPage { padding-top:4rem!important; }
  .tvl-login-native #loginPage>.padded-left.padded-right.padded-bottom-page { padding-left:5vw!important;padding-right:5vw!important;justify-content:flex-start; }
  .tvl-login-native #loginPage>.padded-left::before { margin-bottom:1.6rem; }
  .tvl-login-native #divUsers .card { flex-basis:8rem;width:8rem;margin:.5rem; }
  .tvl-login-native #loginPage .manualLoginForm { padding:1.35rem; }
  .tvl-login-native #loginPage .manualLoginForm h1 { font-size:1.8rem; }
  .tvl-login-native #loginPage .readOnlyContent { grid-template-columns:minmax(0,1fr); }
  .tvl-login-native .formDialog .formDialogHeaderTitle { font-size:1.6rem; }
}
